.container {
  display: 'flex';
  flex-direction: 'column';
  min-height: '100vh';
  zoom: 67%;
  height: 100%;
}
